import React, { Component } from 'react'
import Modal from 'react-modal';
import { Button } from 'components/Buttons'
import "./AuthenticationView.css"

class AuthenticationView extends Component { 

  constructor() {
    super();
    this.state = {
      certModalIsOpen: false,
      certModalHeader: '',
      certModalContent: '',
      certModalImg: '',
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(certModalHeader, certModalContent, certModalImg) {
    this.setState({
      certModalIsOpen: true,
      certModalHeader,
      certModalContent,
      certModalImg,
    });
  }

  closeModal() {
    this.setState({certModalIsOpen: false});
  }

  render() {
    return (
      <div>
        <div className="video-embed-container">
          <iframe title="yt" width="720" height="405" src="https://www.youtube.com/embed/BiUFjssxUOY?modestbranding=1&rel=0" frameBorder="0"></iframe>
        </div>
        <div className="quote-container">
          <div className="quote">
            "If that was your grandfather's putter, how would you want it treated?"
          </div>
          <div className="quote-src">
            - Scotty Cameron, Master Craftsman
          </div>  
        </div>
        <div className="auth-section">
          <div className="auth-section-header">
            Authentication preserves your investment
          </div>
          <div className="auth-section-content">
            Whether you just purchased your putter or are having it customized or restored, you should
            take this opportunity to have it authenticated. If you ever want to insure, donate, sell
            or pass down your putter, our Authentication service removes all doubt of its authenticity -
            - preserving your investment and maintaining the integrity of the Scotty Cameron brand.
          </div>
        </div>
        <div className="auth-section">
          <div className="auth-section-header">
            What is authentication?
          </div>
          <div className="auth-section-content">
            When the Scotty Cameron Custom Shop authenticates your putter, we examine it to
            determine its authenticity to ensure that it is truly a Scotty Cameron putter and that any
            changes made to it were performed by the experts in the Scotty Cameron Custom Shop. We examine
            all of the following aspects of your putter: Shape, Finish, Shaft, Grip, Stamping, Paintfill,
            and Weight to establish the level of authenticity of your putter. We will also describe and
            record any aftermarket changes that have been made to your putter. We do not make
            “grade” distinctions; our process is unbiased and based completely on the facts of the
            putter or merchandise received. 
          </div>
        </div>
        <div className="auth-section">
          <div className="auth-section-header">
            Levels of Authenticity
          </div>
          <div className="auth-section-content">
            When the Scotty Cameron Custom Shop verifies your putter, you will receive a printed
            Certificate of Authenticity (COA). We will also establish a permanent record of your putter
            (including images) in our <a href="//www.scottycameron.com/authentication/registry/">Authentication Registry</a>. 
          </div>
        </div>
        <div className="auth-section">
          <table className="auth-table">
            <thead>
              <tr>
                <th>Certificate</th>
                <th>Shape</th>
                <th>Finish</th>
                <th>Weight</th>
                <th>Stamping</th>
                <th>Paintfill</th>
                <th>Shaft</th>
                <th>Grip</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span className="cert-label cert-link" 
                    onClick={() => this.openModal('Certificate A', 
                    'A putter is given an “A” designation if it retains its original, authentic characteristics or any customizations performed by the Scotty Cameron Custom Shop/Putter Studio. The following criteria have not been altered in the aftermarket in any way: putter shape, stamping, finish, weight, paintfill, shaft or grip. A 100% authentic Scotty Cameron putter will receive a printed Certificate of Authenticity (COA) with a red border, which lists these authentic designations, including pictures of the putter. The COA is embossed with a raised seal and includes a hologram and a registry number beginning with the letter A. An online COA database can be accessed on ScottyCameron.com using this registry number.',
                    '//acushnet.scene7.com/is/image/scottycameron/Authentication_A1?scl=1'
                    )}>Certificate A
                  </span>
                  <br /> 
                  100% Authentic
                </td>
                <td>Authentic</td>
                <td>Authentic</td>
                <td>Authentic</td>
                <td>Authentic</td>
                <td>Authentic</td>
                <td>Authentic</td>
                <td>Authentic</td>
              </tr>
              <tr>
                <td>
                  <span className="cert-label cert-link" 
                    onClick={() => this.openModal('Certificate B', 
                    'In this example, an aftermarket shaft has been installed on the putter. A putter is considered “slightly altered” and would receive a “B” designation if an original Scotty Cameron putter has had any of the following aftermarket changes: paintfill, shaft or grip. A slightly altered Scotty Cameron putter will receive a printed Certificate of Authenticity (COA) with a yellow border, including pictures of the putter and any of the above alterations noted. The COA is embossed with a raised seal, and includes a hologram and a registry number beginning with the letter B. An online COA database can be accessed on ScottyCameron.com using this registry number.',
                    '//acushnet.scene7.com/is/image/scottycameron/Authentication_B?scl=1'
                    )}>Certificate B
                  </span>
                  <br /> 
                  Slight Alteration
                </td>
                <td>Authentic</td>
                <td>Authentic</td>
                <td>Authentic</td>
                <td>Authentic</td>
                <td>Slight Modification</td>
                <td>Slight Modification</td>
                <td>Slight Modification</td>
              </tr>
              <tr>
                <td>
                  <span className="cert-label cert-link" 
                    onClick={() => this.openModal('Certificate C', 
                    'In this example, someone in the aftermarket other than the Scotty Cameron Custom Shop/Putter Studio has added infringing stamping on the face of the putter. This would be considered a “significant modification” and would result in a “C” Certificate of Authenticity (COA) being issued. A putter is considered significantly modified if an original Scotty Cameron putter has had any of the following aftermarket changes, none of which infringe on Titleist/Scotty Cameron trademarks and/or intellectual property: putter shape, finish, stamping or weight. A significantly modified putter will receive a Certificate of Authenticity with a blue border including notations regarding any and all changes to the putter. The COA is embossed with a raised seal, and includes a hologram and a registry number beginning with the letter C. An online COA database can be accessed on ScottyCameron.com using this registry number.',
                    '//acushnet.scene7.com/is/image/scottycameron/Authentication_C?scl=1'
                    )}>Certificate C
                  </span>
                  <br /> 
                  Significant Modification</td>
                <td>Any Modification</td>
                <td>Any Modification</td>
                <td>Any Modification</td>
                <td>Any Modification</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <span className="cert-label">No Certificate issued,</span>
                  <br /> 
                  <span className="cert-link"
                    onClick={() => this.openModal('No Certificate Issued – Stamp that infringes on trademark', 
                    'A putter is considered to have trademark and/or intellectual property modifications if an original Scotty Cameron putter has infringing stamps such as a crown logo, Circle T stamp, Titleist logo, etc., applied in the aftermarket NOT by the Scotty Cameron Custom Shop/Putter Studio. A putter with infringing stamps or marks submitted for authentication will NOT receive a Certificate of Authenticity (COA), but rather a letter with a green border stating that the putter has modifications that infringe on Scotty Cameron/Titleist trademarks and/or intellectual property.'
                    )}>Letter Sent
                  </span>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td>Stamp that infringes on trademark</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <span className="cert-label">No Certificate issued,</span>
                  <br /> 
                  <span className="cert-link"
                    onClick={() => this.openModal('No Certificate Issued – Counterfeit', 
                    'A counterfeit putter was NOT made by, nor has any affiliation with, Titleist and/or Scotty Cameron. It will not receive a Certificate of Authenticity (COA), but rather a letter with a gray border stating that the putter submitted was found to be a counterfeit. If you have mistakenly purchased a counterfeit putter, then we encourage you to visit our page regarding counterfeit product.'
                    )}>Letter Sent
                  </span>
                </td>
                <td colSpan="7">COUNTERFEIT <br />
                  A putter that was NOT made by nor has any affiliation with the Titleist/Scotty Cameron Putter Studio.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="auth-section">
          <img className="img-responsive" 
            alt="Certificate of Authenticity"
            src="//acushnet.scene7.com/is/image/scottycameron/img_Certificate_of_Authenticity?scl=1" />
        </div>
        <Modal className="customizer modal-popup cert-modal" overlayClassName="modal-overlay"
          isOpen={this.state.certModalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Certificate Modal"
        > 
          <div className="close-modal" onClick={this.closeModal}>X</div>
          <div className="cert-modal-header">{this.state.certModalHeader}</div>
          <div className="cert-modal-content">{this.state.certModalContent}
            <br/><br/>
            {this.state.certModalImg && 
              <img className="img-responsive" 
                alt={this.state.certModalHeader}
                src={this.state.certModalImg} />
            }
          </div>
          <Button className="cert-modal-btn" onClick={this.closeModal}>OK</Button>
        </Modal>
      </div>
    );
  }
}

export default AuthenticationView